import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/reports"

export const AssociateReportList = async (values) => {
    return await axiosInstance(options).post(`${path}/associate-list`, values);
}

export const BabeReportList = async (values) => {
    return await axiosInstance(options).post(`${path}/babe-list`, values);
}

export const UserReportDetails = async (id) => {
    return await axiosInstance(options).get(`${path}/details?_id=${id}`);
}

export const UserRegistrationChartData = async () => {
    return await axiosInstance(options).get(`${path}/registrations-chartData`);
}

export const UserActiveInactiveChartData = async () => {
    return await axiosInstance(options).get(`${path}/active-inactive-chartData`);
}

export const AppointmentChartData = async () => {
    return await axiosInstance(options).get(`${path}/appointment-count-chartData`);
}

export const RevenueChartData = async () => {
    return await axiosInstance(options).get(`${path}/calculate-revenue-chartData`);
}
export const RevenueTableData = async (values) => {
    return await axiosInstance(options).post(`${path}/transactions`,values);
}
export const RevenueDetails = async (id) => {
    return await axiosInstance(options).get(`${path}/revenue-details?_id=${id}`);
}

export const ServicesAverageRating = async () => {
    return await axiosInstance(options).get(`${path}/calculate-service-rating`);
}

export const PeakHoursOfServiceBooking = async () => {
    return await axiosInstance(options).get(`${path}/peak-hours-of-booking-chartData`);
}



